/*!
 * Copyright 2018, Selerix Systems, Inc. All Rights Reserved
 * This is unpublished proprietary source code of Selerix, Inc. The
 * copyright notice above does not evidence any actual or intended
 * publication of such source code.
 */

// override for jqxpanel

(function (a) {
	if (a.jqx._jqxPanel.prototype.defaultRender === void 0) {
		a.jqx._jqxPanel.prototype.defaultRender = a.jqx._jqxPanel.prototype.render;
        a.jqx._jqxPanel.prototype.render = function (m) {            
            var b = this;
            if (a.jqx.utilities.scrollBarSize != 15) {
                this.scrollBarSize = a.jqx.utilities.scrollBarSize
            }
            this.host.addClass(this.toThemeProperty("jqx-panel"));
            this.host.addClass(this.toThemeProperty("jqx-widget"));
            this.host.addClass(this.toThemeProperty("jqx-widget-content"));
            this.host.addClass(this.toThemeProperty("jqx-rc-all"));

            var c = $('<div>').attr('id', 'panelWrapper')
                .css({
                    'overflow': 'hidden', 'width': '100%', 'height': '100%', 'background-color': 'transparent',
                    '-webkit-appearance': 'none', 'outline': 'none', 'align': 'left', 'border': '0px', 'padding': '0px', 'margin': '0px', 'left': '0px', 'top': '0px', 'valign': 'top', 'position': 'relative'
                });
            var panelContent = $('<div>').attr('id', 'panelContent')
                .css({
                    '-webkit-appearance': 'none', '-moz-box-sizing': 'border-box', 'box-sizing': 'border-box', 'width': '100%',
                    'height': '100%', 'outline': 'none', 'border': 'none', 'padding': '0px', 'position': 'absolute', 'margin': '0px', 'align': 'left', 'valign': 'top', 'left': '0px', 'top': '0px'
                });
            var verticalScrollBar = $('<div>').attr('id', 'verticalScrollBar')
                .css({
                    'align': 'left', 'valign': 'top', 'left': '0px', 'top': '0px', 'position': 'absolute' 
                });
            var horizontalScrollBar = $('<div>').attr('id', 'horizontalScrollBar')
                .css({
                    'align': 'left', 'valign': 'top', 'left': '0px', 'top': '0px', 'position': 'absolute'
                });
            var bottomRight = $('<div>').attr('id', 'bottomRight')
                .css({
                    'align': 'left', 'valign': 'top', 'left': '0px', 'top': '0px', 'position': 'absolute'
                });
            c.append(panelContent).append(verticalScrollBar).append(horizontalScrollBar).append(bottomRight);
            
            if (!this.host.jqxButton) {
                throw new Error("jqxPanel: Missing reference to jqxbuttons.js.")
            }
            if (!this.host.jqxScrollBar) {
                throw new Error("jqxPanel: Missing reference to jqxscrollbar.js.")
            }
            var d = this.host.children();
            this._rtl = false;
            if (d.length > 0 && d.css("direction") == "rtl") {
                this.rtl = true;
                this._rtl = true
            }
            this.host.wrapInner(c);
            var g = this.host.find("#verticalScrollBar");
            g[0].id = this.element.id + "verticalScrollBar";
            this.vScrollBar = g.jqxScrollBar({
                vertical: true,
                rtl: this.rtl,
                touchMode: this.touchMode,
                theme: this.theme
            });
            var f = this.host.find("#horizontalScrollBar");
            f[0].id = this.element.id + "horizontalScrollBar";
            this.hScrollBar = f.jqxScrollBar({
                vertical: false,
                rtl: this.rtl,
                touchMode: this.touchMode,
                theme: this.theme
            });
            this.content = this.host.find("#panelContent");
            this.wrapper = this.host.find("#panelWrapper");
            this.content.addClass(this.toThemeProperty("jqx-widget-content"));
            this.wrapper[0].id = this.wrapper[0].id + this.element.id;
            this.content[0].id = this.content[0].id + this.element.id;
            this.bottomRight = this.host.find("#bottomRight").addClass(this.toThemeProperty("jqx-panel-bottomright")).addClass(this.toThemeProperty("jqx-scrollbar-state-normal"));
            this.bottomRight[0].id = "bottomRight" + this.element.id;
            this.vScrollBar.css("visibility", "inherit");
            this.hScrollBar.css("visibility", "inherit");
            this.vScrollInstance = a.data(this.vScrollBar[0], "jqxScrollBar").instance;
            this.hScrollInstance = a.data(this.hScrollBar[0], "jqxScrollBar").instance;
            var e = this;
            this.propertyChangeMap.disabled = function (h, j, i, k) {
                e.vScrollBar.jqxScrollBar({
                    disabled: e.disabled
                });
                e.hScrollBar.jqxScrollBar({
                    disabled: e.disabled
                })
            }
                ;
            this.vScrollBar.jqxScrollBar({
                disabled: this.disabled
            });
            this.hScrollBar.jqxScrollBar({
                disabled: this.disabled
            });
            this._addHandlers();
            if (this.width == null) {
                this.width = this.content.width()
            }
            if (this.height == null) {
                this.height = this.content.height()
            }
            this._arrange();
            this.contentWidth = e.content[0].scrollWidth;
            this.contentHeight = e.content[0].scrollHeight;
            if (this.autoUpdate) {
                e._autoUpdate()
            }
            this.propertyChangeMap.autoUpdate = function (h, j, i, k) {
                if (e.autoUpdate) {
                    e._autoUpdate()
                } else {
                    clearInterval(e.autoUpdateId);
                    e.autoUpdateId = null
                }
            }
                ;
            this.addHandler(a(window), "unload", function () {
                if (e.autoUpdateId != null) {
                    clearInterval(e.autoUpdateId);
                    e.autoUpdateId = null;
                    e.destroy()
                }
            });
            this._updateTouchScrolling();
            this._render();
		}
	}
})(jqxBaseFramework);